import React from "react";
import PropTypes from "prop-types";
import {MuiThemeProvider, withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import myTheme from 'common/theme';
import packageJson from '../../package.json';

const styles = theme => ({
    root: {
        textAlign: 'center',
        fontSize: '.7em',
        margin: theme.spacing.unit * 2,
    },
});

class Version extends React.Component {

    render() {

        const {classes} = this.props;

        return (
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.grid}
            >
                <MuiThemeProvider theme={myTheme}>
                    <div className={classes.root}>
                        {packageJson.version} <br />
                        ({process.env.REACT_APP_ENV})
                    </div>
                </MuiThemeProvider>
            </Grid>
        )
    }
}

Version.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(Version)